import { type AppNotification } from '@gb-ticket/shared-types';

export type NotificationAudience = 'agent' | 'portal';

/**
 * Path to open for a notification. New rows carry `href`; legacy helpdesk rows only
 * have a ticket number, so the path is rebuilt for the viewer's side of the helpdesk.
 */
export function notificationTarget(
  item: Pick<AppNotification, 'href' | 'ticketNumber'>,
  audience: NotificationAudience,
): string | null {
  if (item.href) {
    return item.href;
  }
  if (item.ticketNumber) {
    return audience === 'portal'
      ? `/portal/tickets/${item.ticketNumber}`
      : `/helpdesk/tickets/${item.ticketNumber}`;
  }
  return null;
}
